export const localeMap = new Map([
  ['localhost', 'en'],
  ['partners.svc.cpu.ca', 'en'],
  ['partenaires.svc.cpu.ca', 'fr']
])
